import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Description = styled(Text, theme => {
  const regularFontWeight = String(
    theme.fontWeightRegular
  ) as TextStyle['fontWeight']

  return {
    base: {
      fontFamily: theme.fontFamily.regular,
      fontWeight: regularFontWeight,
      textAlign: 'left',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeThreeandhalfpulse,
      paddingTop: theme.paddingInsetNone,
      paddingBottom: theme.paddingInsetNone,
      paddingLeft: theme.paddingInsetNone,
      paddingRight: theme.paddingInsetNone,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
